import { css } from '@microsoft/fast-element';

export const TileCardStyles = css`
  :host {
    display: flex;
  }

  .tile-card {
    display: flex;
    flex-direction: row;
  }

  .rectangule {
    display: flex;
    flex-direction: column;
    width: max-content;
    border-radius: 6px;
    border: 1px solid var(--border-1);
    background-color: var(--card-header-bg);
    box-sizing: border-box;
    color: var(--font-color-1);
    padding: 7px 10px;
    font-size: 12px;
    gap: 10px;
    flex: 1 1 auto;
  }

  .rectangule.inline {
    flex-direction: row;
    align-items: center;
  }

  .value {
    color: var(--white);
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .value ::slotted(span) {
    display: inline-flex;
    align-items: center;
  }
`;
